<template>
  <Card :pt="{ root: { class: { 'p-card--flat': flat } } }">
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
    <template #content><slot /></template>
  </Card>
</template>

<script setup lang="ts">
import type { CardEmits, CardProps } from "primevue";

import { Card } from "primevue";

/* oxlint-disable-next-line perfectionist/sort-intersection-types */
defineProps<{ flat?: boolean } & /* @vue-ignore */ CardProps>();
defineEmits</* @vue-ignore */ CardEmits>();
</script>

<style lang="postcss">
.p-card {
  @apply flex flex-col rounded-xl bg-surface-0 text-surface-700 shadow-[0_1px_3px_0_rgba(0,0,0,0.1),0_1px_2px_-1px_rgba(0,0,0,0.1)];

  &--flat {
    @apply border border-gray-200 shadow-none;
  }

  &-caption {
    @apply flex flex-col gap-2;
  }

  &-body {
    @apply flex h-full flex-col p-5 gap-2;
  }

  &-content {
    @apply h-full;
  }

  &-title {
    @apply text-xl font-medium;
  }

  &-subtitle {
    @apply text-surface-500;
  }
}
</style>
